import { UntypedFormGroup } from "@angular/forms"

export function showFormErrors(fg: UntypedFormGroup): void {
  fg.markAsDirty()
  fg.updateValueAndValidity()
  ;(fg as any)._forEachChild((control: any) => {
    if (control instanceof UntypedFormGroup) {
      showFormErrors(control)
    } else {
      control.markAsDirty()
      control.updateValueAndValidity()
    }
  })
}

export function hideFormErrors(fg: UntypedFormGroup): void {
  fg.markAsPristine()
  fg.updateValueAndValidity()
  ;(fg as any)._forEachChild((control: any) => {
    if (control instanceof UntypedFormGroup) {
      hideFormErrors(control)
    } else {
      control.markAsPristine()
      control.updateValueAndValidity()
      control.hideErrors()
    }
  })
}

function formatError(value: string, code: string): { [key: string]: any } {
  return { [code]: { value } }
}

// empreinte d'un objet édité, pour détecter des modifications non enregistrées (comparaison avant / après).
// Les références Firestore sont réduites à leur chemin ; null, "" et undefined sont équivalents.
export function snapshotForChanges(value: unknown): string {
  return JSON.stringify(value, (key, v) => {
    if (v === null || v === "") return undefined
    if (v && typeof v === "object" && typeof v.path === "string" && typeof v.id === "string") return "ref:" + v.path
    return v
  })
}
